import axios from 'axios'

const authorization = axios.create({
  baseURL: process.env.REACT_APP_API_AUTHORIZATION_BASE_URL,
})

export default authorization
